module.exports = __webpack_public_path__ + "img/tutorial.462806ba.png";